module.exports = __webpack_public_path__ + "img/logo horizontal.19024928.png";